import { createI18n } from 'vue-i18n'
import { watch } from 'vue'
import en from './en.json'
import ar from './ar.json'

const savedLocale = localStorage.getItem('dhikr_locale') || 'ar'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { en, ar },
})

function applyDirection(lang: string) {
  document.documentElement.setAttribute('lang', lang)
  document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr')
}

applyDirection(savedLocale)

watch(() => i18n.global.locale.value, (lang) => {
  localStorage.setItem('dhikr_locale', lang)
  applyDirection(lang)
})

export default i18n
